import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " För att tagluffaieuriopa.se ska fungera behövs nödvändiga cookies. Vi använder också andra cookies för att anpassa och förbättra din upplevelse. ", -1)
const _hoisted_3 = { class: "button-wrapper" }
const _hoisted_4 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "cookie-category" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cookie-category-header-wrapper" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Nödvändiga cookies"),
    /*#__PURE__*/_createElementVNode("div", { class: "cookie-switch-text" }, "Alltid aktiv")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Behövs för att du ska kunna surfa på tagluffaieuropa.se ger oss anonym statistik så att vi kan förbättra webbplatsen. ")
], -1)
const _hoisted_6 = { class: "cookie-category" }
const _hoisted_7 = { class: "cookie-category-header-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Personalisering", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, " Sparar dina inställningar och preferenser för att underlätta kommande besök. ", -1)
const _hoisted_10 = { class: "cookie-category" }
const _hoisted_11 = { class: "cookie-category-header-wrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Marknadsföring", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, " Ger dig personliga erbjudanden på tagluffaieuropa.se och hos våra sammarbetspartner. ", -1)
const _hoisted_14 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Enligt lag om elektronisk information ska besökare på en webbplats i integritetssyfte få information om att cookies används. Informationen i cookien är möjlig att använda för att följa en användares surfande. Cookie är en liten textfil som webbplatsen du besöker begär att få spara på din dator för att ge tillgång till olika funktioner. Det går att ställa in sin webbläsare så att den automatiskt nekar cookies. Mer information kan man hitta på Post och telestyrelsens hemsida. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.pts.se/sv/privat/internet/integritet/kakor-cookies/",
    target: "_blank"
  }, "www.pts.se/sv/privat/internet/integritet/kakor-cookies/"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cookies kan antingen vara förstapartscookies eller tredjepartscookies. Förstapartscookies lagras av webbplatsen som du besöker medan tredjepartscookies lagras av annan part/webbplats än den som du besöker. Tredjepartscookies används exempelvis ofta av annonsnätverk för att identifiera en viss användare och använda information om hur användaren konsumerat innehåll på de olika webbplatserna samt visa (anpassade) marknadsföringsbudskap på de webbplatser som är med i nätverket. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Hur Tågluffa i Europa använder cookies"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tågluffa i Europa använder kakor för att du ska kunna använda Tågluffa i Europas webbplats på det sätt vi avsett, och för att kunna ge dig som besökare en bättre användarupplevelse. Vissa kakor krävs för att Tågluffa i Europas webbplats och våra tjänster ska fungera. Vi använder även marknadsförings- och annonskakor för att kunna leverera anpassat innehåll och funktioner baserat på användarval, samt för att kunna rikta anpassad marknadsföring till dig på andra webbsidor och sociala medier. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Tredjepartscookies"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tredjepartscookies används för att få statistik om antalet användare och detaljer om deras geografi och intressen för att vi ska kunna anpassa innehåll och annonsering därefter. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Google Analytics (trafikmätning)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Vi använder Google Analytics-cookies för att mäta din användning av webbplatsen. Dessa mätningar används för att generera statistik om användningen av webbplatsen och för att identifiera problem med webbplatsen så att vi kan förbättra din användarupplevelse. Varje cookie innehåller ett slumpmässigt genererat ID som används för att känna igen din webbläsare när du får tillgång till en webbplats som använder Google Analytics. Cookien innehåller ingen personlig information och används enbart för webbanalys. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Läs mer här: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://policies.google.com/privacy?hl=sv/",
    target: "_blank"
  }, "https://policies.google.com/privacy?hl=sv"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Du kan säga nej till Google Analytics-cookies här: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://tools.google.com/dlpage/gaoptout",
    target: "_blank"
  }, "http://tools.google.com/dlpage/gaoptout")
], -1)

import { reactive } from "vue";
import CustomModal from "@/components/generics/CustomModal.vue";
import CustomButton from "@/components/generics/CustomButton.vue";
import SwitchCheckbox from "@/components/generics/SwitchCheckbox.vue";
import { useTrackingStore } from "@/store/trackingStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;





const state = reactive({
  cookieInfoShow: true,
  inCookieSettingsView: false,
  detailInfoShow: false,
  personalAccept: true,
  marketingAccept: true,
});

const trackingStore = useTrackingStore();

function handleAcceptCookies() {
  trackingStore.setCookiesAcceptedCookie(
    state.marketingAccept,
    state.personalAccept
  );
  trackingStore.initializeTracking("consent", "default", {
    ad_storage: state.marketingAccept ? "granted" : "denied",
    analytics_storage: state.personalAccept ? "granted" : "denied",
  });
  emit("close");
}

function handleReadMore() {
  state.cookieInfoShow = false;
  state.detailInfoShow = true;
  state.inCookieSettingsView = false;
}

function handleSettingsClick() {
  state.cookieInfoShow = false;
  state.inCookieSettingsView = true;
  state.detailInfoShow = false;
  state.personalAccept = false;
  state.marketingAccept = false;
}

function handleReturnToConfig() {
  state.cookieInfoShow = false;
  state.inCookieSettingsView = true;
  state.detailInfoShow = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomModal, {
    show: __props.show,
    "un-removeable": true,
    "enter-from": "center"
  }, {
    header: _withCtx(() => [
      _createTextVNode(" Cookies ")
    ]),
    body: _withCtx(() => [
      (state.cookieInfoShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(CustomButton, {
                grow: true,
                variant: "outlined",
                onOnClick: _cache[0] || (_cache[0] = ($event: any) => (handleSettingsClick()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Inställningar ")
                ]),
                _: 1
              }),
              _createVNode(CustomButton, {
                grow: true,
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (handleAcceptCookies()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Godkänn alla cookies ")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (state.inCookieSettingsView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" Cookies är små filer med information som lagras i webbläsaren för att förbättra webbplatsen och din upplevelse. "),
            _createElementVNode("div", {
              class: "read-more-link-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleReadMore()))
            }, " Läs mer om cookies "),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(SwitchCheckbox, {
                  onSwitched: _cache[3] || (_cache[3] = ($event: any) => (state.personalAccept = !state.personalAccept))
                })
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(SwitchCheckbox, {
                  onSwitched: _cache[4] || (_cache[4] = ($event: any) => (state.marketingAccept = !state.marketingAccept))
                })
              ]),
              _hoisted_13
            ]),
            _createVNode(CustomButton, { onOnClick: handleAcceptCookies }, {
              default: _withCtx(() => [
                _createTextVNode(" Spara mina val ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (state.detailInfoShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(CustomButton, {
              variant: "outlined",
              onOnClick: handleReturnToConfig
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Tillbaka ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})